export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
            cf.registerFilter("ap_paterno", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.ap_paterno + "-" + item.gestion + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("ap_materno", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.ap_materno + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("nombres", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nombres + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("nro_doc", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.nro_doc + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            return cf.runFilters();
        },
        filterApPaterno(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ap_paterno: val
            });
        },
        filterApMaterno(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ap_materno: val
            });
        },
        filterNombres(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombres: val
            });
        },
        filterNroDoc(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nro_doc: val
            });
        },
        recargar() {
            this.form = {}
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ap_paterno: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                ap_materno: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nombres: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                nro_doc: ""
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/persona/mixins/filtros.js